export default __webpack_public_path__ + "static/media/screenshot1_sm.4e310566.jpg";